import clsx from "clsx";
import Image from "next/image";
import imgCreative from "@ui/images/eleven-creative.png";
import imgAgents from "@ui/images/eleven-agents.png";
import imgApi from "@ui/images/eleven-api.png";
import { BaseLink } from "@ui/components/core/Link";

export function PlatformBadge({
  href,
  platform,
  inverse,
}: {
  href?: string;
  platform: "creative" | "agents" | "api";
  inverse?: boolean;
}) {
  const className = clsx("tw-flex tw-items-center tw-gap-x-2");

  const badge = (
    <>
      <div
        className={clsx(
          "md:tw-size-6 tw-rounded-full md:tw-rounded-md tw-flex tw-items-center tw-justify-center md:tw-ring-1 md:tw-ring-inset",
          inverse ? "tw-bg-white/5 tw-ring-white/7.5" : "tw-bg-black/5 tw-ring-black/7.5",
        )}
      >
        <Image
          src={{ creative: imgCreative, agents: imgAgents, api: imgApi }[platform]}
          alt=''
          width={14}
          height={14}
          className='tw-size-3.5 tw-flex-none tw-rounded-full'
        />
      </div>
      <div className={clsx("tw-type-xs tw-font-medium", inverse ? "tw-text-white" : "tw-text-black")}>
        {{ creative: "ElevenCreative", agents: "ElevenAgents", api: "ElevenAPI" }[platform]}
      </div>
    </>
  );

  if (href) {
    return (
      <BaseLink
        href={href}
        className={clsx(
          className,
          "tw-px-3 -tw-mx-3 tw-h-9 tw-rounded-full tw-outline-none focus-visible:tw-outline-focus",
        )}
      >
        {badge}
      </BaseLink>
    );
  }

  return <div className={className}>{badge}</div>;
}
